import builder from './form-builder';

export default {
  en: {
    title: 'Forms',
    subtitle: 'List of forms to collect data of your customers.',
    alert: {
      submissions: 'Remember to get the form submissions need go to Reports > Form Submissions.',
    },
    form: {
      name: {
        label: 'Name',
        help: 'This name is internal, your customers will not see.',
        error: 'Please provide a name for form.',
      },
      description: {
        label: 'Description',
        error: 'The max characters is {characters}',
      },
    },
    fields: {
      text: 'Text',
      textarea: 'Text field',
      email: 'Email',
      tel: 'Telephone',
      url: 'Website',
      select: 'Single selection',
      radio: 'Radio button',
      checkbox: 'Checkbox',
      time: 'Time',
      number: 'Number',
      multiselect: 'List selection',
      date: 'Date',
      password: 'Password',
      color: 'Color',
      range: 'Range',
      hidden: 'Hidden',
      nps: 'NPS',
      csat: 'CSAT',
      ces: 'CES',
    },
        builder: builder.en,
  },
  es: {
    title: 'Formularios',
    subtitle: 'Lista de formularios para recolectar información de tus clientes.',
    alert: {
      submissions: 'Recuerda que para visualizar los formularios enviados debes ir a Reportes > Formularios Recibidos.',
    },
    form: {
      name: {
        label: 'Nombre',
        help: 'Este nombre es interno, tus clientes no lo verán.',
        error: 'Escriba un nombre válido para el formulario.',
      },
      description: {
        label: 'Descripción',
        error: 'El máximo de caracteres es {characters}',
      },
    },
    fields: {
      text: 'Texto',
        textarea: 'Área de texto',
        email: 'Email',
        tel: 'Teléfono',
        url: 'Sitio Web',
        select: 'Selección única',
        radio: 'Casilla de selección',
        checkbox: 'Casilla de multi-selección',
        time: 'Hora',
        number: 'Número',
        multiselect: 'Selección de lista',
        date: 'Fecha',
        password: 'Contraseña',
        color: 'Color',
        range: 'Rango',
        hidden: 'Oculto',
        nps: 'NPS',
        csat: 'CSAT',
        ces: 'CES',
    },
        builder: builder.es,
  },
  fr: {
    title: 'Formulaires',
    subtitle: 'Liste des formulaires pour collecter les données de vos clients.',
    alert: {
      submissions: 'N\'oubliez pas que pour obtenir les soumissions de formulaire, vous devez aller dans Rapports > Soumissions de formulaires.',
    },
    form: {
      name: {
        label: 'Nom',
        help: 'Ce nom est interne, vos clients ne le verront pas.',
        error: 'Veuillez fournir un nom pour le formulaire.',
      },
      description: {
        label: 'Description',
        error: 'Le nombre maximal de caractères est de {characters}',
      },
    },
    fields: {
      text: 'Texte',
      textarea: 'Champ de texte',
      email: 'Email',
      tel: 'Téléphone',
      url: 'Site web',
      select: 'Sélection unique',
      radio: 'Bouton radio',
      checkbox: 'Case à cocher',
      time: 'Heure',
      number: 'Nombre',
      multiselect: 'Liste de sélection',
      date: 'Date',
      password: 'Mot de passe',
      color: 'Couleur',
      range: 'Plage',
      hidden: 'Masqué',
      nps: 'NPS',
      csat: 'CSAT',
      ces: 'CES',
    },
        builder: builder.fr,
}

};
